"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createImageFromSource = createImageFromSource;
exports.createCroppedImage = createCroppedImage;
const lib_1 = require("../math/lib.js");
/**
 * Asyncronously builds a new {@link HTMLImageElement} from the raw image source string provided.
 * @param imageSource Raw data string of an image to build.
 * @returns A promise to return a new ${@link HTMLImageElement} upon success.
 */
function createImageFromSource(imageSource) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', reject);
        image.src = imageSource;
    });
}
/**
 * Generates a new image {@link Blob} from the original image data and provided crop and rotation.
 * @param originalImageSource Raw data string of unmodified image.
 * @param originalImageType Original ${@link MimeType} of the unmodified image.
 * @param cropArea Cropping dimensions for the image defined as an {@link Area}.
 * @param rotation Rotation amount for the image in degrees.
 * @returns A promise to return a new image {@link Blob} that is cropped and rotated.
 */
function createCroppedImage(originalImageSource, originalImageType, cropArea, rotation) {
    return __awaiter(this, void 0, void 0, function* () {
        const originalImage = yield createImageFromSource(originalImageSource);
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (!originalImage || !context) {
            return null;
        }
        const boundingBoxDimensions = (0, lib_1.transformDimensionWithRotation)({
            height: originalImage.height,
            width: originalImage.width
        }, rotation);
        canvas.height = boundingBoxDimensions.height;
        canvas.width = boundingBoxDimensions.width;
        context.translate(boundingBoxDimensions.width / 2, boundingBoxDimensions.height / 2);
        context.rotate((0, lib_1.getRadiansFromDegrees)(rotation));
        context.translate(-originalImage.width / 2, -originalImage.height / 2);
        context.drawImage(originalImage, 0, 0);
        const cropData = context.getImageData(cropArea.x, cropArea.y, cropArea.width, cropArea.height);
        canvas.height = cropArea.height;
        canvas.width = cropArea.width;
        context.putImageData(cropData, 0, 0);
        return new Promise((resolve) => {
            canvas.toBlob(resolve, originalImageType);
        });
    });
}
//# sourceMappingURL=lib.js.map